import BodyData from './bodyData'

export default BodyData